<template>
  <div class="container flex1">
    <!-- <iframe src="https://www.baidu.com" frameborder="0" width="100%" height="100%"></iframe> -->
    <three class="three"></three>
  </div>
</template>

<script>
import three from '../facility/three.vue';
export default {
  components: { three },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.container {
  width: 100vw;
  height: 100vh;
  .three {
    width: 100%;
    height: 100%;
  }
}
</style>
